import { render, staticRenderFns } from "./Coop.vue?vue&type=template&id=dd978a96&scoped=true&"
import script from "./Coop.vue?vue&type=script&lang=js&"
export * from "./Coop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd978a96",
  null
  
)

export default component.exports